// extracted by mini-css-extract-plugin
export default {"post-info":"postInfo_post-info__JFkaX"};